<div class="watermark" i18n="Watermark when preview mode."  [ngClass]="{'is-phone-portrait': isPhonePortrait }">
    PREVIEW
  </div>